// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7878":"aa4422f3","8151":"08abace4"}[chunkId] + ".chunk.css";
};